import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=0a0d84fe&scoped=true&"
import script from "./Distribute.vue?vue&type=script&lang=js&"
export * from "./Distribute.vue?vue&type=script&lang=js&"
import style0 from "./Distribute.vue?vue&type=style&index=0&id=0a0d84fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d84fe",
  null
  
)

export default component.exports